import React, { useContext } from 'react';
import { DataGrid } from '../../../components/DataGrid/DataGrid';
import moment from 'moment-jalaali';
import { localText } from '../../../langs/fa/data-grid';
import { store } from './reducer';
import { normalizeMobilePhone } from 'fns';

const List = () => {
  const {
    state: { results, progress, limit, users, single },
    dispatch,
  } = useContext(store);

  const columns = [
    {
      field: 'firstName',
      headerName: 'نام',
      flex: 1,
    },
    {
      field: 'lastName',
      headerName: 'نام خانوادگی',
      flex: 1,
    },
    {
      field: 'mobilePhone',
      headerName: 'موبایل',
      width: 130,
    },
    {
      field: 'company',
      headerName: 'شرکت',
      flex: 1,
    },
  ];

  const handlePageChange = ({ page }) => {
    dispatch({ type: 'PAGE', payload: page });
  };
  const handleSelectUser = ({ row, field }) => {
    if (single && users?.length >= 1) {
      alert('فقط مجاز به انتخاب یک کاربر هستید');
      return;
    }
    const user = results?.docs.find((user) => user._id === row.id);
    dispatch({ type: 'ADD_USER', payload: user });
  };

  return (
    <DataGrid
      rows={
        results?.docs?.map((result) => ({
          id: result._id,
          firstName: result?.firstName || '',
          lastName: result?.lastName || '',
          mobilePhone: normalizeMobilePhone(result?.mobilePhone),
          company: result?.company || '',
        })) || []
      }
      columns={columns}
      localeText={localText}
      pageSize={limit}
      rowCount={results?.totalDocs || 0}
      paginationMode="server"
      onPageChange={handlePageChange}
      loading={progress}
      disableMultipleSelection
      onCellClick={handleSelectUser}
      density="compact"
    />
  );
};

export default React.memo(List);
